import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';
import { ApiService } from '@shared/services/api.service';
import { TokenService } from '@shared/services/token.service';
import { UtilsService } from '@shared/services/utils.service';
import { parse, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { IsThisHourPipeModule } from 'ngx-date-fns';
import { environment } from 'src/environments/environment';
import { subMenuItems } from '../submenu';
import { PaymentsMenuService } from '@shared/services/payments-menu.service';
import { utcToZonedTime, zonedTimeToUtc, format } from 'date-fns-tz';

@Component({
  selector: 'app-cash-register',
  templateUrl: './cash-register.component.html',
  styleUrls: ['./cash-register.component.scss']
})
export class CashRegisterComponent {

  public subMenuItems: Array<IToolbarItem> = [];
  public products: any = [];

  public dateFilter: Date | undefined;
  public officeFilter: string = '';
  public offices: any = [];

  public cashiers: any = [];
  public filteredCashiers: any = [];

  public textToSearch: string = '';

  constructor(
    public utils: UtilsService,
    public router: Router,
    public apiService: ApiService,
    public tokenService: TokenService,
    private http: HttpClient,
    private subMenuService: PaymentsMenuService
  ) { }

  ngOnInit() {
    this.subMenuItems = this.subMenuService.getSubMenuItems();

    this.apiService.get('/cashier/get').subscribe((response: any) => {
      this.cashiers = response.map((cashier: any) => {

        let coin_counter = JSON.parse(cashier.coin_counter);
        let coin_counter_aux = '';

        cashier.created_at = this.changeDateToUTCtoMatrid(cashier.created_at);

        cashier.datetime_open = this.changeDateToUTCtoMatrid(cashier.datetime_open);
        cashier.datetime_close = this.changeDateToUTCtoMatrid(cashier.datetime_close);

        for (let key in coin_counter) {
          coin_counter_aux += `<div class="rounded-full bg-green-600 text-white py-1 px-1 inline-block mr-1 mb-1 font-[600]">
            ${key}:${coin_counter[key]}
          </div>`;
        }

        cashier.coin_counter = coin_counter_aux;
        cashier.operation_type = (cashier.operation_type == 0) ? 'Apertura' : 'Cierre';

        return cashier;
      });

      this.filteredCashiers = this.cashiers;
    });

    this.apiService.get('/office/get').subscribe((response: any) => {
      this.offices = response;
    })

  }

  filterResults(text: string) {
    this.filteredCashiers = this.cashiers?.filter((cashier: any) => {

      let validateSearch = true;
      let validateCalendar = true;
      let validateOffice = true;

      let dateDayFString = '';
      let openDateFDate = parse(cashier?.datetime_open, 'yyyy-MM-dd HH:mm:ss', new Date());
      // let openDateFDate = this.changeDateToUTCtoMatrid(cashier?.datetime_open);

      if (!isNaN(openDateFDate.getTime())) {

        dateDayFString = format(openDateFDate, 'dd-MM-yyyy', { locale: es });
      }

      if (this.dateFilter != undefined && this.dateFilter != null) {
        let dateFString = format(this.dateFilter, 'dd-MM-yyyy hh:mm a', { locale: es });
        if (dateDayFString.trim() == '') {
          validateCalendar = false;
        } else {
          validateCalendar = dateFString.includes(dateDayFString);
        }
      }

      if (this.textToSearch.trim() != '') {
        text = this.textToSearch;
        validateSearch = cashier?.office?.name?.toLowerCase().includes(text?.toLowerCase())
          || cashier?.total?.toString().toLowerCase().includes(text?.toLowerCase())
          || cashier?.user_opens?.name?.toLowerCase().includes(text?.toLowerCase())
          || cashier?.user_closes?.name?.toLowerCase().includes(text?.toLowerCase())
          || cashier?.datetime_open?.includes(text?.toLowerCase() ?? '')
          || cashier?.datetime_close?.includes(text?.toLowerCase() ?? '');
      }



      if (this.officeFilter != '') {
        validateOffice = this.officeFilter.toString().toLowerCase().includes(cashier?.office_id);
      }

      return (validateCalendar && validateOffice && validateSearch);

    });
  }
  exportExcel() {
    let dateParam: string = '';
    let officeParam: string = '';
    let searchParam: string = '';


    let cashiersToSend = this.filteredCashiers.map((cashier: any) => {
      const cashierCloned = JSON.parse(JSON.stringify(cashier));
      return cashierCloned.id;
    });

    cashiersToSend = cashiersToSend.join(',');

    console.log('cashiersToSend', cashiersToSend);

    window.open(`${environment.baseUrlWeb}/cashier/export/excel?token=${this.tokenService.getToken()}&cashiers=${cashiersToSend}`);
  }

  printTicketFromCashier(cashierId: number) {

    this.http.get(`${environment.baseUrlWeb}/cashier/print-ticket/${cashierId}/0?token=${this.tokenService.getToken()}`, { responseType: 'blob' }).subscribe((blob: any) => {
      const blobUrl = URL.createObjectURL(blob);
      let iframe: any = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      iframe.contentWindow?.print();
    });

  }

  changeDateToUTCtoMatrid(date: any): string | null {
    if(date == null) return null;
    const timeZone = 'Europe/Madrid';

    const cleanedDate = date.replace(/(\.\d{3})\d{3}Z$/, '$1Z');

    const utcDate = new Date(cleanedDate);

    const madridDate = utcToZonedTime(utcDate, timeZone);

    const output = format(madridDate, 'yyyy-MM-dd HH:mm:ss', { timeZone });

    return output;
  }


}
